module.exports = {"211104001":"荣滨街道","211104002":"二界沟街道","211104003":"荣兴街道","211104004":"大洼街道","211104005":"田家街道","211104006":"榆树街道","211104007":"向海街道","211104008":"前进街道","211104101":"田庄台镇","211104103":"东风镇","211104104":"新开镇","211104106":"清水镇","211104107":"新兴镇","211104108":"西安镇","211104109":"新立镇","211104112":"唐家镇","211104113":"平安镇","211104114":"赵圈河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211104.json
// module id = 532
// module chunks = 0